import React from 'react';
import { FiUser, FiCpu, FiFileText, FiEdit3 } from 'react-icons/fi';
import styles from './ChatMessage.module.scss';

const ChatMessage = ({ message, type }) => {
  const isUser = type === 'user';
  const isActivity = type === 'activity';

  if (isActivity) {
    return (
      <div className={styles.activity_message}>
        <div className={styles.activity_icon}>
          {message.activityType === 'creating' ? (
            <FiFileText size={14} />
          ) : (
            <FiEdit3 size={14} />
          )}
        </div>
        <div className={styles.activity_content}>
          <span className={styles.activity_text}>
            {message.activityType === 'creating' ? 'Created' : 'Edited'} document
          </span>
          {message.version && (
            <span className={styles.activity_version}>v{message.version}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.message} ${isUser ? styles.user_message : styles.ai_message}`}>
      <div className={styles.message_avatar}>
        {isUser ? <FiUser size={16} /> : <FiCpu size={16} />}
      </div>
      <div className={styles.message_content}>
        <div className={styles.message_header}>
          <span className={styles.message_sender}>
            {isUser ? 'You' : 'AI Assistant'}
          </span>
          {message.timestamp && (
            <span className={styles.message_time}>
              {new Date(message.timestamp).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
              })}
            </span>
          )}
        </div>
        <div className={styles.message_text}>
          {message.isStreaming ? (
            <span dangerouslySetInnerHTML={{ __html: message.content }} />
          ) : (
            <span>{message.content}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
